module.exports = __webpack_public_path__ + "img/unknown.7300cfaa.svg";